import { render, staticRenderFns } from "./DebugBtn.vue?vue&type=template&id=00cf4a82&scoped=true&lang=html&"
import script from "./DebugBtn.vue?vue&type=script&lang=js&"
export * from "./DebugBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cf4a82",
  null
  
)

export default component.exports